import type { WorkflowRun } from '../../api/workflowRuns'
import { workflowRunStatusLabel } from '../../lib/workflow/workflowRunDisplay'
import { ChromeToolbarButton } from '../ChromeActions'
import { chromeCardShellClass, chromeMetaTagClass } from '../ChromeSurface'

type Props = {
  angular: boolean
  runs: WorkflowRun[]
  definitionNames: Record<string, string>
  onOpenRun: (run: WorkflowRun) => void
}

export function WorkflowActiveRunsPanel({ angular, runs, definitionNames, onOpenRun }: Props) {
  if (runs.length === 0) return null

  return (
    <section className="mb-6">
      <div className="mb-3 flex items-center justify-between gap-2">
        <h2 className="text-sm font-bold text-ink">进行中的运行</h2>
        <span className={chromeMetaTagClass(angular, 'outline', { hint: true })}>{runs.length}</span>
      </div>
      <div className="space-y-2">
        {runs.map((run) => (
          <div
            key={run.publicId}
            className={['flex flex-wrap items-center justify-between gap-2 px-3 py-2.5', chromeCardShellClass(angular)].join(' ')}
          >
            <div className="min-w-0">
              <p className="truncate text-sm font-semibold text-ink">
                {definitionNames[run.definitionPublicId] ?? '工作流运行'}
              </p>
              <p className="text-xs text-ink-soft">
                {workflowRunStatusLabel(run.status)} · {run.steps.length} 步
              </p>
            </div>
            <ChromeToolbarButton type="button" className="!h-8 shrink-0" onClick={() => onOpenRun(run)}>
              查看进度
            </ChromeToolbarButton>
          </div>
        ))}
      </div>
    </section>
  )
}
